/* eslint-disable react-hooks/rules-of-hooks */
import {DEVICE_HEIGHT} from '../../../constants';
import Offcanvas from 'react-bootstrap/Offcanvas';
import {useNavigate} from 'react-router-dom';
import HamburgerItem from './HamburgerItem';
import {SUB_NAV_LIST} from './subNavData';
import MessageModal from '../MessageModal';
import Nav from 'react-bootstrap/Nav';
import {useState} from 'react';
import {useLanguageContext, useSessionContext, useThemeContext, useAuthContext, useMenuContext} from '../../../context';
import usePermission from '../../../hooks/usePermission';

const HamburgerMenu = () => {
    let navigate = useNavigate();

    const {isVisible, setIsVisible} = useMenuContext();
    const {session, setSession} = useSessionContext();
    const {handleLogoutInDB, hanldlePermission} = useAuthContext();
    const {I18n} = useLanguageContext();
    const {theme} = useThemeContext();

    const [logoutModal, setLogoutModal] = useState(false);
    const [subRoute, setSubRoute] = useState('');

    const toggleMenu = () => setIsVisible(false);

    const handleSelect = route => {
        if (SUB_NAV_LIST[route]) {
            setSubRoute(route);
            return;
        } else if (route == 'logout') setLogoutModal(true);
        else navigate(`/${route}`);
        setIsVisible(false);
        setSubRoute('');
    };

    const handleLogout = async () => {
        setLogoutModal(false);

        if (session) {
            navigate('/session', {
                state: 'logout',
            });
        } else {
            await handleLogoutInDB();

            navigate('/login', {replace: true});
        }
    };

    return (
        <>
            <Offcanvas
                className="navigationSiderbar"
                backdrop={false}
                show={isVisible}
                onHide={toggleMenu}
                style={{
                    backgroundColor: theme.background,
                    height: DEVICE_HEIGHT - 40,
                }}>
                <Offcanvas.Body>
                    <Nav onSelect={route => handleSelect(route)} className="sidePaneNav" variant="pills" activeKey="1">
                        {hanldlePermission('dashboard') && <HamburgerItem hamburgerIcon="dashboardIcon" hamburgerTitle={I18n.dashboard} eventKey="dashboard" />}
                        {hanldlePermission('pos') && <HamburgerItem hamburgerIcon="posNewIcon" hamburgerTitle={I18n.nav_pos} eventKey="pos" />}
                        {hanldlePermission('purchaseorder') && <HamburgerItem hamburgerIcon="purchaseOrderNewIon" hamburgerTitle={I18n.purchase_order} eventKey="purchaseorder" />}
                        {hanldlePermission('reports') && <HamburgerItem hamburgerIcon="reportsIcon" hamburgerTitle={I18n.reports} eventKey="report" />}
                        {hanldlePermission('payments') && (
                            <HamburgerItem hamburgerTitle={I18n.payments} hamburgerIcon="paymentIcon" eventKey={'payments'} subRoute={subRoute === 'payments' ? subRoute : null} />
                        )}
                        {hanldlePermission('items') && <HamburgerItem hamburgerIcon="itemNewIcon" hamburgerTitle={I18n.items} eventKey="items" />}
                        {hanldlePermission('category') && <HamburgerItem hamburgerIcon="categoryIcon" hamburgerTitle={I18n.categories} eventKey="category" />}
                        {hanldlePermission('suppliers') && (
                            <HamburgerItem
                                hamburgerIcon="suppliesIcon"
                                hamburgerTitle={I18n.suppliers}
                                eventKey="suppliers"
                                subRoute={subRoute === 'suppliers' ? subRoute : null}
                            />
                        )}
                        {hanldlePermission('orders') && <HamburgerItem hamburgerIcon="clockhistoryIcon" hamburgerTitle={I18n.orders_history} eventKey="orders" />}
                        {hanldlePermission('customers') && <HamburgerItem hamburgerIcon="customerSquareIcon" hamburgerTitle={I18n.customers} eventKey="customers" />}
                        {hanldlePermission('discounts') && <HamburgerItem hamburgerIcon="discountIcon" hamburgerTitle={I18n.discounts} eventKey="discounts" />}
                        {hanldlePermission('tax') && <HamburgerItem hamburgerIcon="taxNewIcon" hamburgerTitle={I18n.taxes} eventKey="tax" />}
                        {hanldlePermission('team') && <HamburgerItem hamburgerIcon="teamNewIcon" hamburgerTitle={I18n.teams} eventKey="team" />}
                        {hanldlePermission('setting') && <HamburgerItem hamburgerIcon="settingIcon" hamburgerTitle={I18n.settings} eventKey="setting" />}
                        {hanldlePermission('location') && <HamburgerItem hamburgerIcon="settingIcon" hamburgerTitle={I18n.location} eventKey="location" />}
                        {hanldlePermission('device') && <HamburgerItem hamburgerIcon="devices" hamburgerTitle={I18n.devices} eventKey="device" />}
                        <HamburgerItem hamburgerIcon="logoutIcon" hamburgerTitle={I18n.nav_logout} eventKey="logout" />
                    </Nav>
                </Offcanvas.Body>
            </Offcanvas>

            <MessageModal
                setToggle={setLogoutModal}
                className="messageModal"
                toggle={logoutModal}
                title={I18n.logout}
                description={I18n.are_you_sure_you_want_to_logout}
                secondaryCta={{
                    title: I18n.no,
                    action: () => setLogoutModal(false),
                }}
                primaryCta={{
                    title: I18n.logout,
                    action: handleLogout,
                    isDelete: true,
                }}
            />
        </>
    );
};

export default HamburgerMenu;
